/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `MapLayer.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { MapLayer } from "./MapLayer";

import { Project } from "./Project";

export abstract class MapLayerModel {
    id: number;
    captureDate: Dayjs | null;
    createdAt: Dayjs;
    enabled: boolean;
    name: string;
    projectId: number;
    updatedAt: Dayjs;
    url: string;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        captureDate: Dayjs | null,
        createdAt: Dayjs,
        enabled: boolean,
        name: string,
        projectId: number,
        updatedAt: Dayjs,
        url: string,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.captureDate = captureDate;
        this.createdAt = createdAt;
        this.enabled = enabled;
        this.name = name;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.url = url;
        this.project = project;
    }

    static fromApiObject(json: any, timezone: string): MapLayer {
        const newObject = new MapLayer(
            json["id"],
            json["capture_date"] ? dayjs(json["capture_date"]).tz(timezone) : null,
            dayjs(json["created_at"]).tz(timezone),
            json["enabled"],
            json["name"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["url"],
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            capture_date: this.captureDate,
            created_at: this.createdAt,
            enabled: this.enabled,
            name: this.name,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            url: this.url,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): MapLayer {
        const clone = Object.create(this) as MapLayer;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
